import type { Tier } from './look';

// Ported from Sheep Tag main.ts autoQuality: five-second windows, below 42 fps, down only.
// Add a fresh five-second warm-up after interruptions and tier changes. Never average loading or hidden time.
export type QualitySample = { dt: number; tier: Tier; enabled: boolean; playing: boolean; hidden: boolean; loading: boolean };
export type QualityWindow = { warm: number; time: number; frames: number };
export const qualityWindow = (): QualityWindow => ({ warm: 0, time: 0, frames: 0 });
export function autoQuality(state: QualityWindow, sample: QualitySample): { state: QualityWindow; tier: Tier } {
  const { dt, tier } = sample;
  if (!sample.enabled || !sample.playing || sample.hidden || sample.loading || tier === 'light' || !Number.isFinite(dt) || dt <= 0)
    return { state: qualityWindow(), tier };
  if (state.warm < 5) return { state: { warm: state.warm + Math.min(dt, 0.1), time: 0, frames: 0 }, tier };
  // Sheep Tag caps measured dt at 100 ms so one long hitch cannot dominate the window.
  const time = state.time + Math.min(dt, 0.1), frames = state.frames + 1;
  if (time < 5) return { state: { ...state, time, frames }, tier };
  if (frames / time < 42) return { state: qualityWindow(), tier: tier === 'ultra' ? 'best' : 'light' };
  return { state: { warm: 5, time: 0, frames: 0 }, tier };
}
